import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// import { Category } from '../_models';

@Injectable({ providedIn: 'root' })
export class EmployeeService {
    constructor(public http: HttpClient) { }

    public getAll(filter: any = []) {
        return this.http.post<any>(`employees/listEmployee`, filter);
    }

    getById(id: number) {
        return this.http.get(`employees/view/` + id);
    }

    insert(category: any) {
        return this.http.post(`employees/add`, category);
    }

    update(category: any) {
        return this.http.post(`employees/update`, category);
    }

    delete(id: number) {
        return this.http.get(`employees/delete/` + id);
    }
}
